import {Component,Input,Output, OnInit,EventEmitter,ViewChild} from '@angular/core';
@Component({
    selector:'deep-blue-header',
    templateUrl:'app.deepblue.header.html'
})
export class DeepBlueHeaderComponent{
    @Input() SectionDetailsList: any;
    @Input() TestInfo: any;
    @Input() isActiveIrSection: any;
    @Output() ParentHideQuestionNumber = new EventEmitter();
    @Output() ParentHideTimer = new EventEmitter();
    @Output() ParentBookmarkClick = new EventEmitter();
	@Output() ParentShowAnswerClick = new EventEmitter();
	@Output() ParentCheckAnswerClick = new EventEmitter();
    @Input() IsScreenPaused:any;
    @Input() TestPrefController: any;
    @ViewChild('spnBookmark') spnbookmark;
    HideQuestionNumber(){
        this.ParentHideQuestionNumber.emit();
    }
    HideTimer(){
        this.ParentHideTimer.emit();
    }
    BookmarkClick(){        
        this.ParentBookmarkClick.emit(this.spnbookmark.nativeElement);
    }
	ShowAnswer(){        
        this.ParentShowAnswerClick.emit();
    }
	CheckUserAnswer(){        
        this.ParentCheckAnswerClick.emit();
    }
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Headers/Themes/DeepBlue/app.deepblue.ts